import {SaveButton} from '@/components/refinedev/action_buttons';
import {transformBeforeSave, UserForm} from './user-form';
import CreateForm from '@/components/refinedev/pages/create-form';

const UserCreate = () => {
  return (
    <CreateForm transformBeforeSave={transformBeforeSave}>
      <UserForm />
      <SaveButton />
    </CreateForm>
  );
};

export default UserCreate;
